import { render, staticRenderFns } from "./UserChat.vue?vue&type=template&id=60d1fdbf&scoped=true"
import script from "./UserChat.vue?vue&type=script&lang=ts"
export * from "./UserChat.vue?vue&type=script&lang=ts"
import style0 from "./UserChat.vue?vue&type=style&index=0&id=60d1fdbf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d1fdbf",
  null
  
)

export default component.exports